<template>
  <div class="query-header">
    <el-row
      :gutter="20"
    >
      <el-col
        :lg="8"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <div class="label">{{$t('Operation_method')}}</div>
        <el-select
          :placeholder="$t('User.accType')"
          v-model="way"
          :style="prefixStyle"
          class="short-select"
          clearable
          @change="selectChange"
        >
          <el-option
            v-for="(item,index) in wayList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
<!--        具体的出入金方式-->
        <el-select
          v-model="type"
          :placeholder="$t('Way')"
          :style="backHendStyle"
          class="long-select"
          clearable
          @change="toQuery"
        >
          <el-option
            v-for="(item,index) in filterTypeList"
            :key="index"
            :label="item.desc"
            :value="item.payType"
          ></el-option>
        </el-select>
      </el-col>
      <el-col
        :lg="8"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <div class="label">{{$t('state')}}</div>
        <el-select
          v-model="status"
          :placeholder="$t('please_choose')"
          style="width: 100%"
          class=""
          clearable
          @change="toQuery"
        >
          <el-option
            v-for="(item,index) in statusList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col
        :lg="8"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <div class="label">{{$t('processing_time')}}</div>
        <el-date-picker
          v-if="!realMobile"
          style="width: 100%"
          v-model="date"
          type="daterange"
          value-format="yyyy-MM-dd HH-mm-ss"
          :range-separator="phFileter('root.dateTo')"
          :start-placeholder="phFileter('root.startDate')"
          :end-placeholder="phFileter('root.endDate')"
          @change="toQuery"
        >
        </el-date-picker>
        <select-date-duration
          class="header-sub-item"
          v-model="date"
        ></select-date-duration>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "queryHeader",
  props: {
    typeList: {
      type: Array,
      default(){
        return [];
      }
    },
  },
  data() {
    let  _this = this;
    return {
      way: '',
      wayList: [
        {label: _this.$t('Trade.depo'),value: 1}, // 入金
        {label: _this.$t('User.out'),value: 2}, //出金
      ],
      type: '',
      date: [], // 时间
      status: '',
      statusList: [
        {
          label: _this.$t('User.custStatus3'), // 审核中
          value: 0,
        },
        {
          label: _this.$t('User.authPass'),//审核成功
          value: 6
        },
        {
          label: _this.$t('User.reportCommiStatus2'), //审核失败
          value: 99
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['realMobile']),
    filterTypeList() {
      if(!this.typeList.length){
        return []
      }else {
        let enterList = this.typeList.filter((item) => {
          return item.type == 1;
        });
        let outerList = this.typeList.filter((item) => {
          return item.type == 2;
        });
        if(this.way == 1){
          return enterList[0].payTypeList;
        }else if(this.way == 2){
          return outerList[0].payTypeList;
        }
      }
    },
    prefixStyle(){
      if(this.realMobile){
        return {
          width: '120px'
        }
      }else {
        return {
          width: '25%'
        }
      }
    },
    backHendStyle(){
      if(this.realMobile){
        return {
          width: 'calc(100% - 120px)'
        }
      }else {
        return {
          width: '75%'
        }
      }
    }
  },
  methods: {
    phFileter(data){
      return this.$t(data)
    },
    selectChange(){
      this.type = '';
      this.$emit('toQuery');
    },
    toQuery(){
      this.$emit('toQuery');
    }
  },
}
</script>

<style lang="scss" scoped>
.query-header {
  .header-sub-item {
    width: 100%;
  }
}
</style>
